import { useParams } from 'react-router-dom'
import { Page } from '../layout'
import { Loading, Text } from 'ui'
import { useInvoice } from 'queries/payment'
import { InvoiceDetails } from './InvoiceDetails'

export function InvoiceDetailPage() {
  const params = useParams<{ invoiceId: string }>()
  const invoiceId = Number(params.invoiceId)
  const { data: invoice, isLoading } = useInvoice({ invoiceId })

  return (
    <Page title={'Invoice Detail'}>
      {isLoading ? <Loading /> : null}
      {!isLoading && !invoice ? <Text>Invoice unavailable.</Text> : null}
      {invoice ? <InvoiceDetails data={invoice} /> : null}
    </Page>
  )
}
